import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="flex min-h-[70vh] items-center justify-center pt-24">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">404</p>
          <h1 className="mt-3 text-5xl font-medium tracking-tight text-[#1e1b4b]">
            Page not found
          </h1>
          <p className="mt-4 text-slate-600">The page you're looking for doesn't exist.</p>
          <a href="/" className="mt-6 inline-block rounded-xl bg-[#1e1b4b] px-5 py-3 text-sm font-medium text-white">
            ← Back home
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
